/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
export const PERSONA_QUERY_KEYS = {
  all: (workspaceId: string) => ['personas', workspaceId] as const,
  list: (workspaceId: string) => ['personas', workspaceId, 'list'] as const,
  byIds: (workspaceId: string, ids: string[]) =>
    ['personas', workspaceId, 'byIds', ...ids] as const,
  workspaces: (personaId: string) => ['personas', 'workspaces', personaId] as const,
} as const;
